import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import { sub } from 'date-fns';

export default class isUpcoming extends Helper {
  @service clock;

  compute([startsAt]) {
    return (
      this.clock.broadcastTime >= sub(startsAt, { minutes: this.clock.upcomingLookAheadMinutes }) &&
      this.clock.broadcastTime <= startsAt
    );
  }
}
